module.exports = __webpack_public_path__ + "img/titleloan.dae60d61.svg";